import { render, staticRenderFns } from "./TipoDescargas.vue?vue&type=template&id=bde6bede"
import script from "./TipoDescargas.vue?vue&type=script&lang=js"
export * from "./TipoDescargas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports